import React, { Fragment } from 'react';
import { Card, CardBody, Button } from 'reactstrap';
import moment from 'moment';
import styled from 'styled-components';
import Feedback from './Feedback';
const OpitionDiv = styled.div`
  display: block;
  text-align: center;
`;

const ChatMessageItems = ({ item, colors, time, feedback }) => {
  const element1 = JSON.parse(item.text);
  return (
    <Fragment>
      {element1.text && (
        <Card
          className={`tawk-message-group-right tawk-flex-1 d-inline-block mb-3 conversationMessage`}
          style={{
            backgroundColor: colors.botBot,
            color: colors.botBotText,
          }}
        >
          <div
            className="position-absolute  pt-1 pr-2 r-0"
            style={{ top: '0' }}
          >
            {' '}
            <span className="text-extra-small">
              {moment(time).format('DD/MM/YYYY h:mm a')}
            </span>
          </div>
          <CardBody>
            <div className="chat-text-right">
              <p className="mb-0">{element1.text}</p>
            </div>
          </CardBody>
          {feedback !== "" && element1.text.length > 50 && (
            <Feedback feedback={feedback}></Feedback>
          )}
        </Card>
      )}
      <OpitionDiv>
        {' '}
        {element1.buttons.map((e) => {
          return (
            <Fragment>{typeof e !== 'object' &&
              <div
                style={{
                  padding: '5px',
                  display: 'inline-block',
                }}
              >
                <div
                  className="chat-options"
                  style={{
                    backgroundColor: colors.suggestionBackground,
                    color: colors.suggestionText,
                  }}
                >
                  <span>{e}</span>
                </div>
              </div>
            }</Fragment>
          );
        })}
      </OpitionDiv>
    </Fragment>
  );
};

export default ChatMessageItems;
